import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Analytics = forwardRef<SVGSVGElement, SvgIconProps>(
  function Analytics(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M5.98 8.2l2.37-2.37A1.54 1.54 0 019.85 4a1.53 1.53 0 011.51 1.82l2.37 2.37c.27-.08.56-.08.83 0l2.37-2.37a1.54 1.54 0 012.6-1.38 1.54 1.54 0 01-1.63 2.53l-2.28 2.29a1.54 1.54 0 11-2.95 0l-2.28-2.29c-.34.13-.73.13-1.07 0L7.04 9.27a1.53 1.53 0 11-2.8-.36c.35-.6 1.07-.9 1.74-.7zm13.92 9.74H4.1c-.6 0-1.1.46-1.1 1.03 0 .57.5 1.03 1.1 1.03h15.8c.6 0 1.1-.46 1.1-1.03 0-.57-.5-1.03-1.1-1.03zM9.3 9.16c-.35 0-.64.3-.64.68v6.55h2.57V9.84c0-.38-.3-.68-.65-.68H9.3zm9.5 0h-1.26c-.36 0-.65.3-.65.68v6.55h2.57V9.84a.67.67 0 00-.65-.68zm-4.1 3.1h-1.27a.64.64 0 00-.47.2.7.7 0 00-.19.48v3.45h2.57v-3.45a.7.7 0 00-.19-.48.64.64 0 00-.46-.2zm-9.5 0c-.36 0-.66.32-.66.72v3.92h2.57v-3.92c0-.4-.29-.72-.65-.72H5.2z" />
      </SvgIcon>
    )
  },
)

export default Analytics
